const INITIAL_STATE = {
  itemsCart: [],
  pricesItem: [],
  totalPrice: 0,
  segmentState: [],
  idPrice: [],
  preload: true,
  results: [],
  emptyCart: true,
  prueba: [],
  directOnly: false,
  firstSearchData: null,
  searchHistory: [],
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_SEARCH":
      return {
        ...state,
        results: action.payload,
        preload: false,
        directOnly: state.directOnly || action.directOnly,
      };
    case "GET_SEARCH_PASSES":
      return {
        ...state,
        results: action.payload,
        firstKeyProductsOffer: action.dataRequest.firstKeyProducts,
        preload: false,
      };
    case "SELECT_TRAIN":
      return {
        ...state,
        itemsCart: action.itemsCart,
        totalPrice: action.totalPrice,
        pricesItem: action.pricesItem,
        segmentState: action.segmentState,
        idPrice: action.idPrice,
        preload: false,
      };
    case "SAVE_FIRST_SEARCH_DATA":
      return {
        ...state,
        firstSearchData: action.payload,
      };
    default:
      return state;
  }
};
